import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import seoImg from "../assets/SEO analytics team-amico.png";
import ppcImg from "../assets/Conversion rate optimization-amico (1).png";
import socialImg from "../assets/Social media-amico.png";
import webImg from "../assets/Windows-amico.png";
import contentImg from "../assets/Marketing consulting-amico.png";
import emailImg from "../assets/Mobile Marketing-amico.png";
import ecommerceImg from "../assets/Consultative sales-amico.png";

const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};

const staggerContainer = {
  initial: {},
  whileInView: { transition: { staggerChildren: 0.08 } },
};

const cardItem = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};

const SERVICES_DATA = [
  { img: seoImg,       title: "Search Engine Optimization", desc: "Improve search engine rankings and drive consistent, high-quality organic traffic.",         path: "/seo-services-delhi-ncr" },
  { img: ppcImg,       title: "Pay-Per-Click (PPC)",         desc: "Launch targeted advertising campaigns that generate qualified leads and measurable ROI.",   path: "/ppc-services-delhi-ncr" },
  { img: socialImg,    title: "Social Media Marketing",      desc: "Build brand awareness and engage your audience across major social platforms.",             path: "/social-media-marketing-delhi-ncr" },
  { img: webImg,       title: "Web Design & Development",    desc: "Create a responsive and user-friendly website designed to deliver a smooth experience.",    path: "/website-design-development-delhi-ncr" },
  { img: contentImg,   title: "Content Marketing",           desc: "Create strategic and engaging content that builds trust and turns visitors into customers.", path: "/content-marketing-services-delhi-ncr" },
  { img: emailImg,     title: "Email Marketing",             desc: "Engage your audience and nurture leads through personalized email campaigns.",              path: "/email-marketing-services-delhi-ncr" },
  { img: ecommerceImg, title: "Ecommerce Marketing",         desc: "Accelerate growth for your online store with performance-focused marketing strategies.",    path: "/ecommerce-services-delhi-ncr" },
];

function useIsMobile() {
  const [mobile, setMobile] = React.useState(
    typeof window !== "undefined" ? window.innerWidth <= 992 : false
  );
  React.useEffect(() => {
    const handler = () => setMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return mobile;
}

function Services() {
  const isMobile = useIsMobile();

  if (isMobile) {
    // Mobile: clean stacked cards — image on top, text below
    return (
      <section id="services" className="services">
        <motion.div className="services-header" {...scrollReveal}>
          <p className="services-sub">— Our Services —</p>
          <h2>Our Core Digital Marketing Services</h2>
          <p className="services-desc">
            Strategic marketing solutions designed to increase visibility, generate leads, and grow your business online.
          </p>
        </motion.div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {SERVICES_DATA.map((service, i) => (
            <Link
              key={i}
              to={service.path}
              style={{ textDecoration: "none", borderRadius: "12px", overflow: "hidden", display: "block", background: "#ede9fe" }}
            >
              <img
                src={service.img}
                alt={service.title}
                style={{ width: "100%", height: "170px", objectFit: "cover", display: "block" }}
              />
              <div style={{ padding: "10px 14px 14px" }}>
                <h3 style={{ fontSize: "15px", fontWeight: 700, color: "#111827", margin: "0 0 4px", lineHeight: 1.3 }}>
                  {service.title}
                </h3>
                <p style={{ fontSize: "13px", color: "#374151", margin: 0, lineHeight: 1.5 }}>
                  {service.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    );
  }

  // Desktop: original accordion/expand layout
  return (
    <section id="services" className="services">
      <motion.div className="services-header" {...scrollReveal}>
        <p className="services-sub">— Our Services —</p>
        <h2>Our Core Digital Marketing Services</h2>
        <p className="services-desc">
          Strategic marketing solutions designed to increase visibility, generate leads, and grow your business online.
        </p>
      </motion.div>

      <motion.div
        className="services-list"
        variants={staggerContainer}
        initial="initial"
        whileInView="whileInView"
        viewport={{ once: true, amount: 0.1 }}
      >
        {SERVICES_DATA.map((service, index) => (
          <motion.div key={index} className="service-item" variants={cardItem}>
            <Link to={service.path} className="service-item-link" aria-label={service.title}>
              <img src={service.img} alt={service.title} />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <span className="service-arrow">↗</span>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}

export default Services;
